import { fetcher } from "helpers/fetcher";

import {
  TDuplicateBusinessEstablishmentReq,
  TDuplicateBusinessEstablishmentRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const duplicateBusinessEstablishment = async (
  payload?: TDuplicateBusinessEstablishmentReq
) => {
  return await fetcher<
    TDuplicateBusinessEstablishmentRes,
    TDuplicateBusinessEstablishmentReq["data"]
  >(ENDPOINT.CORPORATION.DUPLICATE_BUSINESS_ESTABLISHMENT, {
    data: payload?.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.DUPLICATE_BUSINESS_ESTABLISHMENT.version,
      [API_HEADER.CORP_ID]: payload?.idCorp,
    },
  });
};

export const mutationDuplicateBusinessEstablishment = async (
  payload?: TDuplicateBusinessEstablishmentReq
) => {
  return (await duplicateBusinessEstablishment(payload)).data;
};

mutationDuplicateBusinessEstablishment._key = (
  payload?: TDuplicateBusinessEstablishmentReq
) => [ENDPOINT.CORPORATION.DUPLICATE_BUSINESS_ESTABLISHMENT.url, payload];
